// import { CardContent, Typography, TextField,  IconButton, Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { updateMealPortion, removeEntry } from "../../store/todaySlice";

import { colors, space, radius, borders, fontWeight, fontSize } from "../../design/tokens";

import {
  Card,
  TextInput,
  Button,
  Text,
  Row
} from "../layout";

import { IconTrash } from "@tabler/icons-react";


export default function TodayMealEntryCard({
  entry,
  meals,
  foodsById,
  onAddFood
}) {
  const dispatch = useDispatch();

  

  const meal = meals.find(m => m.id === entry.mealId);
  if (!meal) return null;

  return (
    <Card 
      style={{ 
        borderBottom: `${borders.sm} ${colors.primary}` ,
        borderRadius:"0 !important",
        padding:"0px"      
        }}>

 
        <Row style={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <Text variant="p" style={{
            fontWeight: `${fontWeight.semibold}`, 
            fontSize: `${fontSize.xs}`}}>
            {meal.name}
          </Text>
          <Button
            onClick={() => dispatch(removeEntry(entry.id))}
            style={{
              padding:"0px",
              // background:"none",
              borderRadius:"0px"
            }}
          >
              <IconTrash style={{width:"18px", height: "18px"}}/>
          </Button>
        </Row>

{/* <Button> */}
        {/* </div> */}

        {Object.entries(entry.portions ?? {}).map(([foodId, grams]) => {

          const food = foodsById[foodId];
          if (!food) return null;

          const gramsNumber = Number(grams || 0);
          const calories = ((food.calories * gramsNumber) / 100).toFixed(0);

          return (
             <Row style={{ justifyContent: "space-between", alignItems: "center", width: "100%", marginBottom: "3px", marginTop: "10px" }}
              key={foodId}
            > 
              <Text variant="p" style={{
                fontWeight: `${fontWeight.regular}`, 
                fontSize: `${fontSize.xs}`,
                lineHeight: "1",
                }}>
                
                {food.name} ({calories} kcal)
              </Text>

              <TextInput
                type="number"
                value={grams ?? ""}
                onChange={(e) => {
                  const value = e.target.value;

                  dispatch(updateMealPortion({
                    entryId: entry.id,
                    foodId,
                    grams: value === "" ? "" : Number(value)
                  }));
                }}
                
                slim


                style={{
                  padding: "10px",
                  borderRadius: "10px",
                  width: "100px",
                  fontSize: "16px",
                  lineHeight: "1.1",
                  textAlign: "right",
                  border: "1px solid #000",
                }}
              />

            </Row>

          );
        })} 
        <Button
          slim
          onClick={() => onAddFood(entry.id)}
            style={{
            display: "block",
            margin: "0 auto 5px",
            width: "auto",
            padding: "5px 10px",
            fontSize: "12px",
          }}
        >
          + Add food
        </Button>
    </Card>
  );
}